import { tileCount } from './board';
import { correctEdges } from './edges';
import type { Board, Group } from './types';

/** 只返回 ≥2 块的组，组内与组间都按 tileId 升序 */
export function computeGroups(board: Board): Group[] {
  const N = tileCount(board);
  const parent = Array.from({ length: N }, (_, i) => i);
  const find = (x: number): number => {
    while (parent[x] !== x) {
      parent[x] = parent[parent[x]];
      x = parent[x];
    }
    return x;
  };
  for (const [a, b] of correctEdges(board)) {
    const ra = find(a);
    const rb = find(b);
    if (ra !== rb) parent[Math.max(ra, rb)] = Math.min(ra, rb);
  }
  const byRoot = new Map<number, number[]>();
  for (let t = 0; t < N; t++) {
    const r = find(t);
    const g = byRoot.get(r);
    if (g) g.push(t);
    else byRoot.set(r, [t]);
  }
  return [...byRoot.values()].filter((g) => g.length > 1).sort((a, b) => a[0] - b[0]);
}

/** 组 + 单块，按最小 tileId 升序 */
export function units(board: Board): Group[] {
  const groups = computeGroups(board);
  const grouped = new Set(groups.flat());
  const singles = board.pos.map((_, t) => t).filter((t) => !grouped.has(t)).map((t) => [t]);
  return [...groups, ...singles].sort((a, b) => a[0] - b[0]);
}

export function unitOf(board: Board, tile: number): Group {
  return computeGroups(board).find((g) => g.includes(tile)) ?? [tile];
}

/** max(1, 最大组块数) / 块数 */
export function progress(board: Board): number {
  const largest = Math.max(1, ...computeGroups(board).map((g) => g.length));
  return largest / tileCount(board);
}
